import * as React from "react";
import { createContext, Dispatch, FC, SetStateAction, useContext, useEffect, useState } from "react";
import { IdentifyResultsArray } from "../Map/Identify/identifyUtils";
import { useMapContext } from "./MapContext";

export interface IIdentifyContext {
    loading: boolean;
    setLoading: Dispatch<SetStateAction<boolean>>;
    identifyResults: IdentifyResultsArray;
    setResults: Dispatch<SetStateAction<IdentifyResultsArray>>;
    coordinates: number[];
    setCoordinates: Dispatch<SetStateAction<number[]>>;
    coordinatesString: string;
    setCoordinatesString: Dispatch<SetStateAction<string>>;
}

const IdentifyContext = createContext<IIdentifyContext>(null);

export const useIdentifyContext = (): IIdentifyContext => useContext(IdentifyContext);

export const IdentifyContextProvider: FC = (props: React.PropsWithChildren<IIdentifyContext>) => {
    const { formatType, getCurrentFormatCoords, featuresPopup } = useMapContext();

    const [loading, setLoading] = useState<boolean>(false);
    const [identifyResults, setResults] = useState<IdentifyResultsArray>();
    const [coordinates, setCoordinates] = useState<number[]>();
    const [coordinatesString, setCoordinatesString] = useState<string>("");

    useEffect(() => {
        setCoordinatesString(getCurrentFormatCoords(coordinates));
    }, [formatType, coordinates]);

    useEffect(() => {
        if (!featuresPopup) {
            return;
        }
        setCoordinates(featuresPopup.coordinates);
        setResults(featuresPopup.results);
    }, [featuresPopup]);

    const values = {
        loading,
        setLoading,
        identifyResults,
        setResults,
        coordinates,
        setCoordinates,
        coordinatesString,
        setCoordinatesString
    };

    return <IdentifyContext.Provider value={values}>{props.children}</IdentifyContext.Provider>;
};
